"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const onscan_js_1 = __importDefault(require("onscan.js"));
const HandScanner = ({ handleOnScan }, ...props) => {
    (0, react_1.useEffect)(() => {
        onscan_js_1.default.attachTo(document, {
            // stopPropagation: true, // Stop immediate propagation on keypress event
            // preventDefault: true, // Prevent default action on keypress event
            onScan: function (sScancode, iQuantity) {
                handleOnScan(sScancode);
            },
        });
        console.log('Scan attached!');
        return () => {
            // cleanup
            console.log('Scan cleanup!');
            onscan_js_1.default.detachFrom(document);
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.default = HandScanner;
